import { render, staticRenderFns } from "./AssignCardToMaterialModal.vue?vue&type=template&id=6cf01c61&scoped=true&"
import script from "./AssignCardToMaterialModal.vue?vue&type=script&lang=js&"
export * from "./AssignCardToMaterialModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf01c61",
  null
  
)

export default component.exports